import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { ViewConstants } from "src/app/constants";
import { SubSink } from "subsink";
import { IAppCoreState } from "../state";
import { getUserInfo } from "../state/selectors";
import * as Models from '../../shared/model/api/models';
import { SharedDataService } from "../services/shared-data.service";

@Injectable()
export class DealServiceInterceptor implements HttpInterceptor {
    public _subs = new SubSink();

    constructor(private readonly _store: Store<IAppCoreState>,  private readonly sharedDataService: SharedDataService,) { }

    intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clonedReq: HttpRequest<any> = httpRequest.clone();
        const debugInfo: Models.DebugInfo = {
            'date': new Date().toUTCString(),
            'sender': ViewConstants.CON
        }

        this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
            if (userInfo) {
                debugInfo.salesAssociateName = `${userInfo.first_name  } ${  userInfo.last_name}`;
                debugInfo.salesAssociateUserId = userInfo.UserId;
                debugInfo.initialCall = this.sharedDataService?.calculateClickedOnceAfterLoad ? 'false' : 'true';
                debugInfo.dealTransactionId = this.sharedDataService?.dealTransactionIdInfo ? this.sharedDataService.dealTransactionIdInfo : null;
            };
        });

        const urlPatterns = [
            'deals/dealers/',
            'retail-deals/dealers/',
            'retail-deals/trade',
            'deals/sendDealToFinance',
            'payment-nexgen',
            'digitalfi',
            'email-notification',
            'sms-notification',
            'upload'
          ];
          
          if (urlPatterns.some(pattern => clonedReq.url.includes(pattern)) && clonedReq.body) {
            const existingDebugInfo: Models.DebugInfo = clonedReq.body.debugInfo || {};
            // Keep the screenName/userAction set at the firing point; the interceptor owns every other field.
            clonedReq.body.debugInfo = { ...existingDebugInfo, ...debugInfo, screenName: existingDebugInfo.screenName ?? '', userAction: existingDebugInfo.userAction ?? '' };
          }
          
          return next.handle(clonedReq);
    }
}